import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

export interface FileHistoryDownloadRequest {
  historyId: string;
}

export const updateFileHistoryDownload = ({
  historyId,
}: FileHistoryDownloadRequest) => {
  return api.put<ApiResponse<undefined>>('/file/history/download', {
    historyId,
  });
};

export const updateBulkFileHistoryDownload = ({
  historyId,
}: FileHistoryDownloadRequest) => {
  return api.post<ApiResponse<undefined>>('/v2/viewer/submit/download', {
    historyId,
  });
};

const useFileDownload = <TError = AxiosError<ApiErrorResponse>>(
  isBulk = false,
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    FileHistoryDownloadRequest,
    QueryKey
  >,
) => {
  return useMutation(
    isBulk ? updateBulkFileHistoryDownload : updateFileHistoryDownload,
    {
      ...options,
    },
  );
};

export default useFileDownload;
